import React from 'react';
import { ChurchStaqIcon, ParishStaqIcon, PushpayLogoWithoutTextIcon } from '@pushpay/iconography';
import { clsx } from '@pushpay/styles';
import { useMediaBreakpoint } from '@pushpay/theming';
import useStyles from './use-styles-old';

const HeaderTemplate = ({
  classes: classesProp,
  className: classNameProp,
  'data-pp-at-target': targetId,
  logo = 'pushpay',
  mobileMenuButton,
  leftSection,
  toolBar,
  rightSection,
  ...rest
}) => {
  const isTabletAndBelow = useMediaBreakpoint('TABLET_PORTRAIT_AND_BELOW');
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);

  const renderLogo = () => {
    if (logo === 'pushpay') {
      return /*#__PURE__*/React.createElement(PushpayLogoWithoutTextIcon, {
        title: "Pushpay",
        "data-pp-at-target": `${targetId}-pushpay-logo`,
        className: classes.pushpayLogo
      });
    }

    if (logo === 'churchStaq') {
      return /*#__PURE__*/React.createElement(ChurchStaqIcon, {
        title: "ChurchStaq",
        "data-pp-at-target": `${targetId}-churchstaq-logo`,
        className: classes.churchStaqLogo
      });
    }

    if (logo === 'parishStaq') {
      return /*#__PURE__*/React.createElement(ParishStaqIcon, {
        title: "ParishStaq",
        "data-pp-at-target": `${targetId}-parishstaq-logo`,
        className: classes.parishStaqLogo
      });
    }

    return logo;
  };

  return /*#__PURE__*/React.createElement("header", Object.assign({
    className: className
  }, rest), isTabletAndBelow ? /*#__PURE__*/React.createElement("div", {
    className: classes.mobileMenuButtonWrapper
  }, mobileMenuButton) : /*#__PURE__*/React.createElement("div", {
    className: classes.logoWrapper
  }, renderLogo()), /*#__PURE__*/React.createElement("div", {
    className: classes.leftSide
  }, leftSection), /*#__PURE__*/React.createElement("div", {
    className: classes.toolBar
  }, toolBar), /*#__PURE__*/React.createElement("div", {
    className: classes.rightSide
  }, rightSection));
};

export default HeaderTemplate;